import { Col, Row } from "reactstrap";
import "./index.css";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import { useContext } from "react";
import { StudentContext } from "Context/StudentContext";
import styled from "styled-components";
import { ProgramActionCode } from "utilFunctions/Constants/Constants";
import {
  RiskStyledDSpan,
  RiskStyledDiv,
} from "Pages/BranchHealth/BranchHealthTable";
import MsTeamIcon from "Assets/Icons/MsTeamIcon";
import NoResultFoundSearch from "Components/CommonComponents/NoResultFoundSearch/NoResultFoundSearch";
import NoStudentDetailsIcon from "Assets/Icons/NoStudentDetailsIcon";
import moment from "moment";
const StudentDetailsHeader = [
  {
    label: "Application Number",
    value: "admApplicationNumber",
  },
  {
    label: "PSID",
    value: "psid",
  },
  {
    label: "Course ID",
    value: "courseId",
  },
  {
    label: "Stream",
    value: "stream",
  },
  {
    label: "Academic Career",
    value: "acadCareer",
  },
  {
    label: "Program Action",
    value: "programAction",
  },
  {
    label: "Business Unit",
    value: "branch",
  },
  {
    label: "Term",
    value: "academicYear",
  },
  {
    label: "Course Start Date",
    value: "courseStartDate",
  },
  {
    label: "Course End Date",
    value: "courseEndDate",
  },
  {
    label: "Course Class",
    value: "courseClass",
  },
  {
    label: "Secondary Batch",
    value: "batchName",
  },
  {
    label: "Primary Batch",
    value: "primaryBatch",
  },
  {
    label: "Batch Class",
    value: "clazz",
  },
  {
    label: "Effective Date",
    value: "effectiveDate",
  },
  {
    label: "Byjus",
    value: "byjusActive",
  },
  {
    label: "MS Teams",
    value: "msTeamsActive",
  },
  {
    label: "iTutor",
    value: "itutorActive",
  },
];
const DetailMainSubDiv1 = styled<any>("div")`
  width: ${(props: any) =>
    ["xxl", "xl", "lg"].includes(props.screen) ? "30%" : "70"};
`;
const DetailMainSubDiv2 = styled<any>("div")`
  width: ${(props: any) =>
    ["xxl", "xl", "lg"].includes(props.screen) ? "70%" : "30"};
  display: flex;
  overflow: auto;
`;
const DetailHeaderDiv = styled<any>("div")`
  background-color: ${(props: any) => (props.isHeader ? "#fcfcfc" : "#fff")};
  font-weight: ${(props: any) => (props.isHeader ? 600 : "400")};
  border: ${(props: any) =>
    props.isHeader
      ? "0.5px solid var(--Grey-20, #eee)"
      : "0.5px solid var(--Grey-20, #eee)"};
  padding: 8px 16px;
  height: 44px;
  white-space: nowrap;
`;
export const ElmentDetail = ({ label, value }: any) => {
  return (
    <div className="d-flex flex-column">
      <span className="studentLabel">{label}</span>
      {label == "Faculty Email ID" ? (
        <span className="studentValueBlue mt-1">{value}</span>
      ) : (
        <span className="studentValue mt-1">{value}</span>
      )}
    </div>
  );
};
const StudentDetailsTab = () => {
  const { screen }: any = useWindowSize();
  const { selectedStudent, allBasicDetails } = useContext<any>(StudentContext);

  const returnProgramAction = (programAction: string) => {
    const isColorCode = ProgramActionCode.includes(programAction);
    return (
      <RiskStyledDiv color={isColorCode ? "#E6F4ED" : "#FCEEED"}>
        <RiskStyledDSpan color={isColorCode ? "#50B47F" : "#E7685A"}>
          {programAction}
        </RiskStyledDSpan>
      </RiskStyledDiv>
    );
  };
  const renderColumn = (ele: any, column: any) => {
    const formattedDate = moment(ele[column.value], "DD-MM-YYYY").format(
      "DD MMM YYYY"
    );
    switch (column.value) {
      case "programAction":
        return (
          <span className="studentLabel">
            {returnProgramAction(ele[column.value])}
          </span>
        );
      case "courseStartDate":
      case "courseEndDate":
        return <span className="studentLabel">{formattedDate}</span>;
      case "effectiveDate":
        return (
          <span className="studentLabel">
            {moment(ele[column.value]).format("DD MMM YYYY")}
          </span>
        );
      case "byjusActive":
      case "msTeamsActive":
      case "itutorActive":
        return (
          <span className="studentLabel">
            <RiskStyledDiv color={ele[column.value] ? "#E6F4ED" : "#FCEEED"}>
              <RiskStyledDSpan
                color={ele[column.value] ? "#50B47F" : "#E7685A"}
              >
                {ele[column.value] ? "Active" : "Inactive"}
              </RiskStyledDSpan>
            </RiskStyledDiv>
          </span>
        );
      default:
        return <span className="studentLabel">{ele[column.value]}</span>;
    }
  };
  const renderHeader = (header: any) => {
    switch (header.label) {
      case "MS Teams":
        return (
          <span className="studentValue d-flex align-items-center">
            {header.label} <MsTeamIcon className="pl-1" />
          </span>
        );
      case "iTutor":
        return (
          <span className="studentValue d-flex align-items-center">
            {header.label}
          </span>
        );
      default:
        return <span className="studentValue">{header.label}</span>;
    }
  };
  console.log("allBasicDetails", allBasicDetails);
  return (
    <div
      className={
        ["xxl", "xl", "lg"].includes(screen)
          ? "StudentDetailsTabCard"
          : "StudentDetailsTabCardMB"
      }
    >
      {allBasicDetails && allBasicDetails.length ? (
        <Row
          className={
            ["xxl", "xl", "lg"].includes(screen) ? "detailRow" : "detailRowMB"
          }
        >
          <Col xxl="4" xl="4" lg="4" md="4" sm="12" xs="12">
            <ElmentDetail
              label={"Student Name"}
              value={selectedStudent?.name || "NA"}
            />
          </Col>
          <Col xxl="4" xl="4" lg="4" md="4" sm="6" xs="6">
            <ElmentDetail
              label={"Father Name"}
              value={selectedStudent?.fatherName || "NA"}
            />
          </Col>
          <Col xxl="4" xl="4" lg="4" md="4" sm="6" xs="6">
            <ElmentDetail
              label={"Mother Name"}
              value={selectedStudent?.motherName || "NA"}
            />
          </Col>
        </Row>
      ) : null}
      {allBasicDetails && allBasicDetails.length ? (
        <div className="detailMainDiv">
          <DetailMainSubDiv1>
            {StudentDetailsHeader.map((ele: any, index: number) => {
              return (
                <DetailHeaderDiv key={index} isHeader={true}>
                  <span className="studentValue">{renderHeader(ele)}</span>
                </DetailHeaderDiv>
              );
            })}
          </DetailMainSubDiv1>

          <DetailMainSubDiv2>
            {allBasicDetails &&
              allBasicDetails.map((ele: any, index: number) => {
                return (
                  <div key={index}>
                    {StudentDetailsHeader.map(
                      (column: { label: string; value: string }) => (
                        <DetailHeaderDiv key={index} isHeader={false}>
                          {renderColumn(ele, column)}
                        </DetailHeaderDiv>
                      )
                    )}
                  </div>
                );
              })}
          </DetailMainSubDiv2>
        </div>
      ) : (
        <div className="noStudentFound">
          <NoResultFoundSearch
            primaryMessage="Student details not available "
            secondaryMessage={
              "The student details data is currently pending synchronization in the system; please check back shortly."
            }
          >
            <NoStudentDetailsIcon />
          </NoResultFoundSearch>
        </div>
      )}
    </div>
  );
};
export default StudentDetailsTab;
